export default "__VITE_ASSET__DDqNyuk2__"